import React, { useState, useEffect } from 'react';
import { Box, IconButton, Flex, useMediaQuery } from '@podiumhq/design-system';
import { useTracking } from '@podiumhq/tracking';

import useInitIpqs from 'components/ThirdPartyScripts/hooks/useInitIpqs';
import { useTrialsContext } from 'contexts/TrialsContextProvider';
import { useCountryByIpQuery } from 'hooks/queries/useCountryByIpQuery';
import useChangePage from 'hooks/useChangePage';
import useEventListener from 'hooks/useEventListener';
import { TRIAL_URL } from 'routes/constants';

import SignupContent from './SignupContent';
import Imagery from 'components/Trials/components/Animations/SignUpPage';

const RoiSignupPage = () => {
  const changePage = useChangePage();
  const country = useCountryByIpQuery();
  const { trackEvent } = useTracking();
  const { accountExists, hasValidLogin, inviteExists, isInMarketingIframe } =
    useTrialsContext() || {};

  const [isInView, setIsInView] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSmallerThan850px] = useMediaQuery('(max-width: 850px)');

  useInitIpqs(isInView);

  const handleSubmit = () => {
    setIsSubmitting(true);

    hasValidLogin(true)
      .then((isValidAccountDetails) => {
        trackEvent('trials.accountInfo.nextClicked', {
          valid: isValidAccountDetails,
        });

        setIsSubmitting(false);

        if (isValidAccountDetails && inviteExists) {
          changePage('user-invite-exists');
        }

        if (isValidAccountDetails && !accountExists && !inviteExists) {
          changePage(`${TRIAL_URL}/profile`);
        }
      })
      .catch((error) => {
        trackEvent('trials.accountInfo.error', {
          error: JSON.stringify(error),
        });
        setIsSubmitting(false);
      });
  };

  const handlePageIsInView = (event) => {
    // TODO: add origin to make sure we are getting the right message
    if (event?.data === 'start trial clicked') {
      setIsInView(true);
    }
  };

  useEffect(() => {
    if (!isInMarketingIframe) {
      setIsInView(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEventListener({
    eventName: 'message',
    handler: isInMarketingIframe ? handlePageIsInView : null,
  });

  useEffect(() => {
    if (isInView) {
      trackEvent('trials.accountInfo.visited');

      country()
        .then((response) => console.log(response))
        .catch((error) => console.error(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInView]);

  const handleClose = () => {
    window.parent.postMessage('hideCheckoutModal', '*');
  };

  return (
    <Box height="100vh">
      {isInMarketingIframe && (
        <IconButton
          onClick={handleClose}
          type="XClose"
          size="md"
          variant="ghost"
          fillColor="silver.light"
          position="absolute"
          marginTop="32px"
          right="32px"
          zIndex="1"
          sx={{
            background: 'black.lighter',
            _hover: { background: 'black.lightest' },
          }}
        />
      )}
      <Flex>
        <SignupContent
          isSubmitting={isSubmitting}
          handleSubmit={handleSubmit}
          isMobile={isSmallerThan850px}
        />
        {!isSmallerThan850px && <Imagery />}
      </Flex>
    </Box>
  );
};

export default RoiSignupPage;
